import t from 'lib/i18n';
import "styles/components/favourites/empty.scss";

import Panel from 'components/ui/Panel';
import Button, { ButtonSizes, ButtonVariants } from 'components/ui/Button';
import { ReactComponent as AddFavouriteIcon } from "static/images/favourite-add.svg";

const FavouritesEmpty = () => (
  <div className="otrl-jp__favourites-empty">
    <div className="otrl-jp__favourites-empty__message">{t("favourites.empty.message")}</div>
    <div className="otrl-jp__favourites-empty__helper">
      <div className="otrl-jp__favourites-empty__helper__message">{t("favourites.empty.helper.message")}</div>
      <Panel>
        <Button
          className="otrl-jp__favourites-empty__button"
          disabled
          size={ButtonSizes.SM}
          variant={ButtonVariants.TEXT}
        >
          <AddFavouriteIcon className="otrl-jp__favourites-empty__button__favourite-icon" />
          {t("favourites.empty.helper.button")}
        </Button>
      </Panel>
    </div>
  </div>
);

export default FavouritesEmpty;